module.exports = __webpack_public_path__ + "static/media/Sopilka2.84d5e24a.mp3";